<template>
  <vs-table hover-flat v-if="transferNumbers && transferNumbers.length" :data="transferNumbers">
    <template slot="thead">
      <vs-th v-text="$t('representative_number')"></vs-th>
      <vs-th v-text="$t('no')"></vs-th>
      <vs-th class="text-center" v-text="$t('status')"></vs-th>
      <vs-th class="text-center" v-text="$t('function')"></vs-th>
    </template>

    <template slot-scope="{data}">
      <vs-tr :key="key" v-for="(tr, key) in data">
        <vs-td v-text="tr.title" :data-tr-title="$t('representative_number')"></vs-td>
        <vs-td v-text="tr.channel" :data-tr-title="$t('no')"></vs-td>
        <vs-td class="text-center text-left-on-mobile" :data-tr-title="$t('status')">
          <badge-transfer :status="tr.status"></badge-transfer>
        </vs-td>
        <vs-td class="text-center">
          <div class="flex justify-center">
            <vx-tooltip :text="tr.status ? $t('untransfer') : $tc('transfer')" position="bottom">
              <vs-button
                color="success"
                :type="tr.status ? 'filled' : 'border'"
                icon-pack="feather"
                icon="icon-log-out"
                size="small"
                @click="tr.status ? $emit('unTransfer', tr.id) : $emit('transfer', tr.id)">
              </vs-button>
            </vx-tooltip>

            <span class="pr-2 pl-2">|</span>

            <vs-button color="primary" type="border" icon-pack="feather" icon="icon-edit" size="small" @click="$emit('edit', tr.id)"></vs-button>
          </div>
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
  <vs-alert v-else class="flex justify-center p-0 h-auto" color="danger" active="true">
    <div v-text="$t('no_record')"></div>
  </vs-alert>
</template>

<script>

import BadgeTransfer from '@/components/badge/Transfer'
export default {
  name: 'Shared.Transfers.List',
  components: {
    BadgeTransfer
  },
  props: {
    transferNumbers: {
      type: [Object, Array],
      required: true
    }
  }
}
</script>

<style scoped>

</style>
